import { getGoogleId, getRequestParams } from "../../pages_android/custom_views/insta_custom_views/utils_android/CookieHelper"
import fetchWithTimeout, { getHttpParams, getRequestUrl } from "../../pages_android/custom_views/insta_custom_views/utils_android/UrlHelperAndroid"
import { error, log, onResponse } from "./ApiUtils"

export class UsersApi {

    static getMyFriends(onSuccess, onError) {
        const params = getRequestParams()
        fetchWithTimeout(getRequestUrl() + "getMyFriends", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("getMyFriends response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("getMyFriends error = ", e)
            error(onError, { response: -1 })
        })
    }
    // Привязка Telegram: код из ответа бота @mobile_zarabotok_bot на /start
    static addTelegramToEmployer(telegramCode, onSuccess, onError) {
        var params = getRequestParams()
        params['telegram_code'] = telegramCode
       
        fetchWithTimeout(getRequestUrl() + "addTelegramToEmployer", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("addTelegramToEmployer response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("addTelegramToEmployer error = ", e)
            error(onError, { response: -1 })
        })
    }
    static getMyInfoEmployer(onSuccess, onError) {
        const params = getRequestParams()
        fetchWithTimeout(getRequestUrl() + "getMyInfoEmployer", getHttpParams(params)).then((response) => response.json())
        .then((responseData) => {
            log("getMyInfoEmployer response = ", responseData)
            onResponse(responseData, onSuccess, onError)
        })
        .catch((e) => {
            log("getMyInfoEmployer error = ", e)
            error(onError, { response: -1 })
        })
    }


}
